import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { BRAND } from "../lib/constants";

export const Footer = () => {
    return (
        <footer
            className="bg-ls-ink text-ls-bg"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-6">
                        <div className="font-serif text-[56px] md:text-[96px] leading-[0.95] tracking-tight">
                            Starten wir.
                        </div>
                        <a
                            href={`mailto:${BRAND.email}`}
                            className="mt-6 inline-block font-serif italic text-2xl md:text-3xl ls-underline"
                            data-testid="footer-email"
                        >
                            {BRAND.email}
                        </a>
                        <div className="mt-6">
                            <a
                                href={BRAND.instagram}
                                target="_blank"
                                rel="noreferrer noopener"
                                className="inline-flex items-center gap-3 text-sm font-sans text-ls-bg/80 hover:text-ls-bg transition-colors"
                                data-testid="footer-instagram"
                            >
                                <Instagram size={18} />
                                {BRAND.instagramHandle}
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-[10px] uppercase tracking-[0.28em] text-ls-bg/50 mb-5 font-sans">
                            Seiten
                        </div>
                        <ul className="space-y-3 font-sans text-sm">
                            <li>
                                <a
                                    href="#about"
                                    className="hover:text-white/70 transition-colors"
                                >
                                    Über uns
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#services"
                                    className="hover:text-white/70 transition-colors"
                                >
                                    Leistungen
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#contact"
                                    className="hover:text-white/70 transition-colors"
                                >
                                    Kontakt
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-[10px] uppercase tracking-[0.28em] text-ls-bg/50 mb-5 font-sans">
                            Rechtliches
                        </div>
                        <ul className="space-y-3 font-sans text-sm">
                            <li>
                                <Link
                                    to="/impressum"
                                    className="hover:text-white/70 transition-colors"
                                    data-testid="footer-impressum"
                                >
                                    Impressum
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/datenschutz"
                                    className="hover:text-white/70 transition-colors"
                                    data-testid="footer-datenschutz"
                                >
                                    Datenschutzerklärung
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-ls-bg/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs font-sans text-ls-bg/60">
                    <div>
                        © {new Date().getFullYear()} {BRAND.name}. Alle Rechte
                        vorbehalten.
                    </div>
                    <div className="tracking-[0.2em] uppercase">
                        Designed & developed in Germany
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
